import { useState } from 'react'
import { connect } from 'react-redux'

// Components
import { SelectedOptions } from 'components/filter/filters/sliderdropdown/sliderdropdown'
import MobileMenu from 'components/mobilemenu'
import SearchAndSort from 'components/filter/searchandsort'

// Hooks
import { IconFilter } from '@tracklib/kit'

// Selectors
import { selectSearchToQuery } from 'modules/browse/selectors'

// Types
import { State } from 'types'

import styles from './wrapper.css'

type WrapperProps = {
  sortModes: Array<{ value: number; name: string }>
  selectedFilters: Array<string>
  filterInputPlaceholder: string
  children: (toggleMobileFilterVisible: (visible: boolean) => void) => JSX.Element
  hideDisplayMode?: boolean
  // mapStateToProps
  activeFilters: number
}

const Wrapper = ({
  sortModes,
  filterInputPlaceholder,
  children,
  activeFilters,
  hideDisplayMode,
  selectedFilters,
}: WrapperProps): JSX.Element => {
  const [mobileFilterVisible, toggleMobileFilterVisible] = useState(false)

  const toggleMobileFilter = () => toggleMobileFilterVisible(!mobileFilterVisible)

  return (
    <>
      {sortModes.length || selectedFilters.length ? (
        <div className={mobileFilterVisible ? styles.filtersActive : styles.filters}>
          <button onClick={toggleMobileFilter} className={styles.toggle} datatesting="toggle_filter">
            {filterInputPlaceholder}{' '}
            <span className={styles.icon}>{activeFilters ? <SelectedOptions count={activeFilters} /> : <IconFilter />}</span>
          </button>
          <MobileMenu visible={mobileFilterVisible} toggle={toggleMobileFilterVisible}>
            {children(toggleMobileFilterVisible)}
          </MobileMenu>
        </div>
      ) : null}
      <SearchAndSort sortModes={sortModes} filterInputPlaceholder={filterInputPlaceholder} hideDisplayMode={hideDisplayMode} />
    </>
  )
}

const mapStateToProps = (state: State) => {
  const { ordering, ...currentQueryWithoutOrder } = selectSearchToQuery(state) // eslint-disable-line
  const activeFilters = Object.keys(currentQueryWithoutOrder)

  // if multitrack and types is active remove 1 from count as multitrack is nested inside types
  const activeFiltersLength =
    activeFilters.includes('types') && activeFilters.includes('multitrack') ? activeFilters.length - 1 : activeFilters.length
  return {
    activeFilters: activeFiltersLength,
  }
}
export default connect(mapStateToProps)(Wrapper)
